
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import ModalTitle from "@/lib/model/exam/modal-title";
import ModalHeader from "@/components/modal-header.vue";

@Component({
  components: {
    ModalHeader
  }
})
export default class DelExamModal extends Vue {
  name = "del-new-modal";
  @Prop() private isShowDelModal!: boolean;
  @Prop() private modalTitle!: ModalTitle;
  @Prop({
    type: String,
    required: false,
    default: "删除面试将同时删除该面试下所有候选人记录，确定要删除本场面试吗？"
  })
  text!: boolean; //文字说明
  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  checkMe!: boolean; //是否输入框二次确认

  @Emit("on-del-cancel")
  delCancel() {
    this.inputValue = "";
    this.showAlert = false;
    return;
  }
  inputValue = "";
  showAlert = false;

  delSuccess() {
    if (this.checkMe && this.inputValue !== "确认删除") {
      // this.$message.warning("输入有误，请重试");
      this.showAlert = true;
      return;
    }
    this.showAlert = false;
    this.$emit("on-del-success");
    this.inputValue = "";
  }
}
